import React from 'react';
import { hasAnalysisAccess } from '../../services/subscriptionService';
import { useAnalysisEntitlement } from '../../hooks/analysis/useAnalysisEntitlement';
import UpsellPanel from './shared/UpsellPanel';
import LoadingSpinner from '../../utils/LoadingSpinner';
import './analysis-theme.css';

/**
 * Entitlement gate for the Analysis subtree.
 *
 * | status                  | behavior                                   |
 * |-------------------------|--------------------------------------------|
 * | none/expired/cancelled  | UpsellPanel (locked)                       |
 * | trial / expired_grace   | children (banner rendered by the layout)   |
 * | active                  | children                                   |
 */
const SubscriptionGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { entitlement, loading, error, refresh } = useAnalysisEntitlement();

  if (loading) {
    return (
      <div className="analysis-root analysis-gate-state">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="analysis-root analysis-gate-state">
        <p>⚠️ Could not verify your Analysis subscription: {error}</p>
        <button type="button" className="chart-panel-toggle" onClick={refresh}>
          Retry
        </button>
      </div>
    );
  }

  if (!hasAnalysisAccess(entitlement)) {
    return (
      <div className="analysis-root">
        <UpsellPanel entitlement={entitlement} />
      </div>
    );
  }

  return <>{children}</>;
};

export default SubscriptionGate;
